export const SVG_COLOR = Styles.color.primary;
